
























































import {Component, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import {MOBILE_PHONE_REGEX} from "@/shared/constant";
import {register} from "@/modules/auth/service";

@Component({
    name: "Register"
})
export default class extends Vue {
    private form = {
        email: "",
        phoneNumber: "",
        password: "",
        passwordConfirm: ""
    };

    private rules = {
        email: [{ required: true, type: "email", message: "Nhập email", trigger: "change" }],
        phoneNumber: [
            { required: true, message: "Nhập số điện thoại", trigger: "change" },
            { pattern: new RegExp(MOBILE_PHONE_REGEX), message: "Số điện thoại không hợp lệ", trigger: "blur" }
        ],
        password: [{ required: true, validator: this.passwordValidator, trigger: "change"}],
        passwordConfirm: [{ required: true, validator: this.passwordConfirmValidator, trigger: "change"}]
    };

    private passwordValidator(rule: any, value: any, callback: Function) {
        if (value === "") {
            callback(new Error("Nhập mật khẩu"));
        } else {
            if (this.form.passwordConfirm !== "") {
                (this.$refs.formRegister as FormModel).validateField("passwordConfirm", () => 1);
            }
            callback();
        }
    }

    private passwordConfirmValidator(rule: any, value: any, callback: Function) {
        if (value === "") {
            callback(new Error("Nhập lại mật khẩu"));
        } else if (value !== this.form.password) {
            callback(new Error("Mật khẩu không khớp"));
        } else {
            callback();
        }
    }

    private onSubmit() {
        (this.$refs.formRegister as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                await register(this.form);
            } catch (e) {
                console.log(e);
            }
        })
    }
}
